import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import TransactionHeader from '../containers/transactions/TransactionHeader';
import TransactionFilter from '../containers/transactions/TransactionFilter';
import TransactionList from '../containers/transactions/TransactionList';


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <TransactionHeader />
          <TransactionFilter />
          <PageContentWrapper>
            <TransactionList />
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
